<template>
	<div id="appbox">
		<div class="top_heard">
				<div class="top_box" v-if="screenWidth>785">
					<div class="logo_box" @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					
					<div class="top_search_box" v-if="screenWidth>785" >
						<div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								
								>
							  </el-option>
							</el-select>
							<!-- <i class="el-icon-search"></i> -->
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
						</div>
						  
					</div>
				
				</div>
				<div class="top_tab_box">
					<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
						<template #left>
							<div class="vannav_title" style="color: #217495;font-size: 16px;" >
								活动详情
							</div>
						</template>
						<template #title>
							<div class="vannav_title" style="width: 180px;padding: 20px;">
									<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
							</div>
						</template>
					  <template #right>
						  <van-icon name="ellipsis"  size="20"    />
					  </template>
					</van-nav-bar>
					<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
						<van-picker
						  title=""
						  show-toolbar
						  :columns="vannavlist"
						  confirm-button-text="进入"
						  @confirm="vanlinkgo"
						  @cancel="vannavmenushow"
						  @change="onChange"
						/>
					</van-popup>
					<div class="toptabnav" v-if="screenWidth>785">
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#FE7C2B"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
							<el-menu-item index="/Home">首页</el-menu-item>
							<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
							<el-menu-item index="/Courselist" >研学课程</el-menu-item>
							<el-submenu index="/institution">
							    <template slot="title">研学机构</template>
							    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
							    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
								<el-menu-item index="/traveler" >会员单位</el-menu-item> 
							  </el-submenu>
							
							<el-menu-item index="/Campmap" >研学地图</el-menu-item>
							<el-menu-item index="/Activitylist">活动中心</el-menu-item>
							<el-menu-item index="/Linelist" >研学线路</el-menu-item>
							<el-submenu index="/yanxueteam">
							    <template slot="title">研学团队</template>
							    <el-menu-item index="/mentorlist" >研学导师</el-menu-item>
							    <el-menu-item index="/expertlist" >专家团队</el-menu-item>
							  </el-submenu>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
				</div>
			</div>
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="acttop_box" :style="screenWidth>785?'':'width:100%; flex-direction: column;'">
				<div class="acttop_imgs" :style="screenWidth>375?'':'padding:10px 0px;'">
					    <el-carousel :height="screenWidth>375?'210px':(screenWidth*210/375)+'px'">
					      <el-carousel-item v-for="item in actdata.lunbo" :key="item">
					        <h3 class="small"  style="height: 100%;"><img :src="item" style="width: 100%;height: 100%;" alt="" srcset=""></h3>
					      </el-carousel-item>
					    </el-carousel>
				</div>
				<div class="acttop_msg" :style="screenWidth>785?'':'width:calc(100% - 40px);padding:10px;'">
					<el-descriptions class="margin-top" :style="screenWidth>785?'':'width:100%;'" :title="actdata.title" :column="screenWidth>785?2:1"  border>
					    <el-descriptions-item   label-class-name="my-label">
					      <template slot="label">
					        <!-- <i class="el-icon-user"></i> -->
					        主办单位
					      </template>
					      {{actdata.unit}}
					    </el-descriptions-item>
					    <el-descriptions-item label-class-name="my-label">
					      <template slot="label">
					        <!-- <i class="el-icon-mobile-phone"></i> -->
					        报名开始时间
					      </template>
					      {{actdata.bstart}}
					    </el-descriptions-item>
						<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    报名结束时间
						  </template>
						  {{actdata.bend}}
						</el-descriptions-item>
					    <el-descriptions-item label-class-name="my-label">
					      <template slot="label">
					        <!-- <i class="el-icon-location-outline"></i> -->
					        活动开始时间
					      </template>
						  {{actdata.start}}
					    </el-descriptions-item>
						<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    <!-- <i class="el-icon-location-outline"></i> -->
						    活动结束时间
						  </template>
						  {{actdata.end}}
						</el-descriptions-item>
		<!-- 				<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    活动线路
						  </template>
							{{actdata.route.title}}
						</el-descriptions-item> -->
					    <el-descriptions-item label-class-name="my-label">
					      <template slot="label">
					        活动收费
					      </template>
						  <div class="" style="color: red;">
						  	{{actdata.diy_price==0&&actdata.is_free==0?'￥'+actdata.price:actdata.price}}
						  </div>
					    </el-descriptions-item>
						<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    活动创建人
						  </template>
						  <div class="" >
						  	{{actdata.manager.truename}}
						  </div>
						</el-descriptions-item>
						<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    联系方式
						  </template>
						  <div class="">
						  	{{actdata.manager.mobile}}
						  </div>
						</el-descriptions-item>
					  </el-descriptions>
					  <!-- <div class="baoming_tips" v-if="screenWidth>785">
					  	扫描右侧二维码进行报名
					  </div> -->
				</div>
			</div>
			<div class="actmain_box" :style="screenWidth>785?'':'width:100%; flex-direction: column;'">
				<div class="act_main" :style="screenWidth>785?'':'width:100%;'">
					<div class="actmain_item">
						<div class="actmain_title"  :style="screenWidth>785?'':'font-size:18px;'">
							<span class="actblock" :style="screenWidth>785?'':'height:30px;'" ></span>活动简介
						</div>
						<div class="richbox" v-html="actdata.introduction"></div>
					</div>
					<div class="actmain_item">
						<div class="actmain_title" :style="screenWidth>785?'':'font-size:18px;'">
							<span class="actblock" :style="screenWidth>785?'':'height:30px;'"  ></span>活动须知
						</div>
						<div class="richbox" v-html="actdata.notice"></div>
					</div>
					<div class="actmain_item">
						<div class="actmain_title" :style="screenWidth>785?'':'font-size:18px;'" >
							<span class="actblock" :style="screenWidth>785?'':'height:30px;'"  ></span>活动详情
						</div>
						<div class="richbox" v-html="actdata.content"></div>
					</div>
				</div>
				<div class="quicknewslist" :style="screenWidth>785?'border: 0px;':'width:calc(100% - 3px);'">
						<div class="quick_title">
							评论({{commenttotal}})
						</div>
						<div class="replybox"  v-if="screenWidth>785">
							<div class="reply_rate">
								评分:
								<el-rate
								  v-model="replyrate"
								  allow-half=true
								  show-score
								  text-color="#ff9900"
								  score-template="{value}">
								</el-rate>
							</div>
							<div class="reply_input">
								<el-input
								  type="textarea"
								  :autosize="{ minRows: 2, maxRows: 4}"
								  placeholder="请输入评论内容"
								  v-model="replytext">
								</el-input>
							</div>
							<div class="reply_buttonbox">
								<el-upload
									class="upload-demo"
									action=""
									:accept="acceptmedia" 
									:before-upload="beforeAvatarUpload"
									:http-request="upload"
									multiple
									:limit="maxcount"
									:on-exceed="handleExceed"
									:on-remove="beforeRemove"
									:file-list="fileList">
								  <el-button size="small" icon="el-icon-picture-outline"  type="primary">上传</el-button>
								  <div slot="tip" class="el-upload__tip">上传图片或视频，上传一种后无法传另一种</div>
								</el-upload>
								 <el-button type="success"  v-if="!token" @click="reply()">发表评论</el-button>
								 <el-popover
								   placement="top"
								 	v-model="showreplyvisible"
								    trigger="manual">
								   <div class="verify-box">
								   	<slide-verify
								   	  ref="replyRef"
								   	  :l="42"
								   	  :r="10"
								   	  :w="280"
								   	  :h="280"
								   	  :imgs="images"
								   	  slider-text="向右滑动"
								   	  @success="onreplySuccess"
								   	  @fail="onreplyFail"
								   	  @refresh="onreplyRefresh"
								   	  @fulfilled="onRefreshComplete"
								   	  @again="onreplyAgain"
								   	>
								   	</slide-verify>
								   </div>
								   <el-button type="success"  slot="reference" v-if="token" @click="showreplyvisible = true">发表评论</el-button>
								 </el-popover>
							</div>
						</div>
						<div class="commentlistbox" v-if="commentlist.length">
							<div class="commentitem"   v-for="(item, index) in commentlist" :key="item" >
								<div class="comment_icon">
									<img :src="item.user.avatarUrl" alt="" srcset="">
								</div>
								<div class="commentmainbox">
									<div class="comment_rate">
										<el-rate
										  v-model="item.star"
										  disabled
										   allow-half=true
										  show-score
										  text-color="#ff9900"
										  score-template="{value}">
										</el-rate>
									</div>
									<div class="commentmaintext">
										<span style="color:#409EFF;" >{{item.user.nickName+'：'}}</span>
										{{item.content}}
									</div>
									<div class="comment_medium">
										<div class="medium_imgs" v-for="(imgs, index) in item.imgs" :key="imgs">
											  <el-image 
											    style="width: 100px; height: 100px"
											    :src="imgs" 
											    :preview-src-list="item.imgs">
											  </el-image>
											<!-- <img :src="imgs" alt="" srcset=""> -->
										</div>
										<div class="medium_video" v-for="(vdo, index) in item.videos" :key="vdo">
											<video :src="vdo" controls="controls"  style="width: 100%;height: 160px;"></video>
										</div>
									</div>
									<div class="comment_msg">
										<div class="comment_time">
											{{item.create_time}}
										</div>
										<div class="replyreply" style="color:brown;"  v-if="screenWidth>785&&item.uid==userdata.id" @click="deletereply(item.id)">
											删除评价
										</div>
									</div>
								</div>
								
							</div>
						</div>
						<div class="comment_more">
							<el-pagination
							  background
							  :page-size="15"
							  :hide-on-single-page="true"
							  @current-change="commentpagechange"
							  layout="total, prev, pager, next"
							  :total="commenttotal">
							</el-pagination>
						</div>
					</div>
				
			</div>
			
		</div>
		<el-dialog
		  title="您还未登录,请登录后再操作"
		  :visible.sync="loginshow"
		  width="30%"
		  :before-close="onAgain"
		  center>
		  <div class="wxcode_img">
			<wxlogin
			    href="data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3ggLnRpdGxlIHsgZGlzcGxheTogbm9uZSB9Ci5pbXBvd2VyQm94IC5xcmNvZGUgeyB3aWR0aDogMTgwcHg7IG1hcmdpbi10b3A6IDEwN3B4IH0KLmltcG93ZXJCb3ggLmpzX3d4X2RlZmF1bHRfdGlwIHA6bnRoLWNoaWxkKDIpIHsgZGlzcGxheTogbm9uZSB9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLnN1Y2MgeyBiYWNrZ3JvdW5kLXNpemU6IDEwMCU7IGJhY2tncm91bmQtcG9zaXRpb24teTogLTMxcHghaW1wb3J0YW50O30KLmltcG93ZXJCb3ggLmljb24zOF9tc2cgeyB3aWR0aDogMjZweDsgaGVpZ2h0OiAyN3B4OyB9"
			    id="wxcode"
			    theme=""
			    :state="wxdata.state"    
			    :appid="wxdata.appid"  
			    scope="snsapi_login"
			    :redirect_uri="encodeURIComponent(wxdata.redirect_uri)"
			></wxlogin>
		  </div>
		  
		<!--  <el-form ref="form" :model="form" :rules="rules"label-width="100px">
			  <el-form-item label="手机端账号" prop="mobile">
			      <el-input v-model="form.mobile"></el-input>
			    </el-form-item>
				 <el-form-item label="密码" prop="password">
				    <el-input type="password" v-model="form.password" ></el-input>
				  </el-form-item>
				  <div class=""  @click="goregister()" style="color: #409EFF;width: 100%;text-align: right;">
				  	注册账号
				  </div>
		  </el-form>
		  <span slot="footer" class="dialog-footer" style="padding-top: 0px;">
		    <el-button @click="loginshow = false" style="margin-right: 15px;">取 消</el-button>
			<el-popover
			  placement="top"
				v-model="showvisible"
			   trigger="manual">
			  <div class="verify-box">
			  	<slide-verify
			  	  ref="slideRef"
			  	  :l="42"
			  	  :r="10"
			  	  :w="280"
			  	  :h="280"
			  	  :imgs="images"
			  	  slider-text="向右滑动"
			  	  @success="onSuccess"
			  	  @fail="onFail"
			  	  @refresh="onRefresh"
			  	  @fulfilled="onRefreshComplete"
			  	  @again="onAgain"
			  	>
			  	</slide-verify>
			  </div>
			  <el-button type="primary" slot="reference" @click="showvisible = true">登 录</el-button>
			</el-popover>
		  </span> -->
		</el-dialog>
		<!-- <div class="swim_box"  v-if="screenWidth>785">
			<div class="swim_title">
				报名活动
			</div>
			<div class="swim_code">
				<img :src="actdata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		   <div :class="tops?'navbar':'navbar-top'"  v-if="screenWidth>785" >
		        <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		                <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
						<div style="font-size: 14px;">首页</div></a>
		        </el-tooltip>
		<!--        <el-tooltip class="item" effect="dark" content="客服" placement="left">
		            <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"><i class="el-icon-service"></i></a>
		        </el-tooltip> -->
				<div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		        <div  class="qrShow right" v-if="showQR">
					<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		        </div>
		       
		        <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		            <a @click="gotop"><i class="el-icon-caret-top"></i>
		            <br>
		            <span>顶部</span></a>
		        </el-tooltip>
		    </div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;padding-top:20px;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="item in bottomnav" :key="item" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
			<div class="row" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'" >
				<!-- <div class="copy-left">
					<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
					<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
					<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
				</div> -->
				
				<div class="copy-left " :style="screenWidth>785?'':'width:40%;'" >
					<div class="bottom_logo"  v-if="screenWidth>785" >
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					
				</div>
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'" abort="">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import wxlogin from 'vue-wxlogin';
	import { getActypes, getActivitylist, getPc,getactcomment,checktoken,regettoken,phonelogin,ratecomment,getuserdata,getTempKeys,checkUpload,commentdelete,getbottomnav,getcodepre} from '@/request/api'
	import COS from "cos-js-sdk-v5";
	
	
	export default {
	  name: "Activitylist",
	  components: {
	      wxlogin   //和上面引入名称保持一致
		},
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			bottomnav:[],
			//搜索相关
			top_search_url:'/Siteall',
			options: [{
							value: '/Siteall',
							label: '全站搜索'
						},{
			          value: '/Camplist',
			          label: '营地搜索'
			        }, {
			          value: '/Baselist',
			          label: '基地搜索'
			        }, {
			          value: '/Courselist',
			          label: '课程搜索'
			        },{
			          value: '/Newslist',
			          label: '资讯搜索'
			        },
					{
					  value: '/Activitylist',
					  label: '活动搜索'
					},
					{
					  value: '/Linelist',
					  label: '线路搜索'
					},
					{
					  value: '/mentorlist',
					  label: '导师搜索'
					},],
					//搜索相关
			wxdata:{
				
			},
			phoneboxshow:false,
			activeIndex2: '/Activitylist',
			userInfo: {
			  username: "",
			  education_name: "",
			  role_level: ""
			},
			logintype:true,
			banner:[
			],
			types:[],
			actlist:[],
			quicklist:[],
			aclist:[],
			newsiconon:'',
			category_id:0,
			total:0,
			page_index:1,
			actdata:{},
			uuid:'',
			pcsetdata:{},
			comment_pageindex:1,
			commentlist:[],
			commenttotal:0,
			replyrate:5,
			loginshow:false,
			replytext:'',
			houzhui:'.jpg',
			acceptmedia:'.jpeg, .png, .jpg, .gif, .mp4',
			form: {
				mobile: '',
				password: '',
				openid:'',
				unionid:'',
				is_pc:1,
			},
			userdata:{
				
			},
			maxcount:9,
			fileList:[],
			//侧边栏
			 showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
			tops:false,
			heights:window.innerHeight,
			scrolltop:'',
			//滑块验证码
			images: [
				require('../../../static/img/滑块1.jpg'),
				require('../../../static/img/滑块2.jpg'),
				require('../../../static/img/滑块3.jpg')
			],
			tipsMsg:'',
			isSuccess: true,
			showvisible:false,
			//评论滑块
			showreplyvisible:false,
			//屏幕宽高
			// 屏幕宽度
			screenWidth: window.innerWidth,
			top_bannerWidth:Math.round(window.innerWidth/3.42),
			// 屏幕高度
			screenHeight: window.innerHeight,
			//手机端导航栏
			vannavshow:false,
			manage_url:'/',
			manageoptions:[
				{
				  value: '/',
				  label: '管理入口'
				}, {
				  value: 'https://yxwy.wanjiaxiao.cn/',
				  label: '机构管理后台'
				},
				 {
					value:'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
					 label: '研学OA平台'
				 }
			],
			vannavlist:[
				{
					link:'/Home',
					text:'研学首页'
				},
				{
					link:'/Camplist',
					text:'营地列表'
				},
				{
					link:'/Newslist',
					text:'资讯资讯'
				},
				{
					link:'/Baselist',
					text:'基地列表'
				},
				{
					link:'/Courselist',
					text:'研学课程'
				},
				{
					link:'/Activitylist',
					text:'研学活动'
				},
				{
					link:'/Linelist',
					text:'研学线路'
				},
				
				{
					link:'/mentorlist',
					text:'研学导师'
				},
				{
					link:'/expertlist',
					text:'专家团队'
				},
			],
		  }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		   this.getpcset()
	  },
	  mounted() {
		 const { id } = this.$route.query;
		 this.uuid = id
		  window.addEventListener('resize', this.handleResize, true)
		 this.getDetails()
		 this.getbottomnav()
		 this.getcodepre()
		 var token = localStorage.getItem('token')||''
		 this.token=token
		 if(token){
			 this.getuserdata()
		 }
		 window.addEventListener('scroll', this.scrollToTop)
		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },// 销毁监听
		beforeDestroy() {
		  window.removeEventListener('resize', this.handleResize);
		},
	  methods: {
		  gotopsearch(){
		  		  this.$router.push({
		  		    path: this.top_search_url,
		  		    name: this.top_search_url,
		  		    query: {
		  		      stitle: this.stitle,
		  		    }
		  		  }); 
		  },
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		  vanlinkgo(e){
		  		  console.log(e)
		  		  this.$router.push({
		  		    path: e.link,
		  		    name: e.link,
		  		    query: {
		  		    }
		  		  }); 
		  },
		  vannavmenushow(){
		  		this.vannavshow=false  
		  },
		  handleResize() {
		  		   this.top_bannerWidth = 0;
		    this.screenWidth = window.innerWidth;
		  		this.top_bannerWidth=window.innerWidth/3.42
		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
		    this.screenHeight = window.innerHeight;
		  },
		  getcodepre(){
			var data={
				pre:''
			}  
			getcodepre(data).then(res=>{
				console.log(res)
				this.wxdata=res.data.data
			})
		  },
		  onreplySuccess(){
		  						  // this.isSuccess = true;
		  						  this.showreplyvisible=false
		  						  this.reply()
		  						  this.$refs.replyRef.reset();
		  },
		  onreplyFail(){
		  						  
		  },
		  onreplyRefresh(){
			  
		  },
		  onreplyAgain(){
			   this.$refs.replyRef.reset();
			   this.showreplyvisible=false
			  // this.loginshow=false
		  },
					// 成功回调
		  			  onSuccess(){
		  				  this.tipsMsg = '恭喜您，验证成功啦！';
		  				  this.isSuccess = true;
		  						  this.showvisible=false
		  						  this.phonelogin()
		  						  this.$refs.slideRef.reset();
		  			  },
					  
		  			  // 失败回调
		  			  onFail(){
		  				  this.tipsMsg = '验证失败，请重试哦！';
		  				  this.isSuccess = false;
		  			  },
		  			  // 点击刷新回调
		  			  onRefresh(){
		  				  this.tipsMsg = ''
		  			  },
		  			  // 刷新成功后回调
		  			  onRefreshComplete(){
		  						  this.tipsMsg = ''
		  						  this.isSuccess = true;
		  			  },
		  			  // 检测到非人为操作
		  			  onAgain() {
		  						  
		  						this.$refs.slideRef.reset();
		  						 this.showvisible=false
		  						this.loginshow=false
		  			  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15,
					  flag:99
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
			  
		  deletereply(id){
			  var that=this
			      var data ={
			        id:id
			      }
				  this.$confirm('此操作将永久删除该评论, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				  }).then(() => {
					commentdelete(data).then(res=>{
						this.$alert("评论删除成功", '删除成功', {
							confirmButtonText: '确认',
							callback: action => {
								that.comment_pageindex=1
								that.getactcomment()
							}
						  });
					})
				  }).catch(() => {
					this.$message({
					  type: 'info',
					  message: '已取消删除'
					});          
				  });
		  },
		  getuserdata(){
			getuserdata().then(res=>{
				this.userdata=res.data.data
			})  
		  },
		  gologin(){
			  this.$router.push({
			    path: "/Login",
			    name: "/Login",
				  query: {
				  }
			  });
		  },
		   beforeAvatarUpload(file) {
			   var token = localStorage.getItem('token')||''
			   if(!token){
			     this.gologin()
			     return false
			   }
			   console.log(file)
		        // 设置图片格式 
		        const imgArr = ["image/jpeg", "image/png", "image/jpg", "image/gif","video/mp4"];
		        const isJPG = imgArr.includes(file.type);
		        // const isLt2M = file.size / 1024 / 1024 < 2;
		  
		        if (!isJPG) {
					this.$alert("上传图片只能是JPG格式、PNG格式或GIF格式,视频只能是MP4格式，且视频与图片只能传一种", '上传文件格式错误', {
						confirmButtonText: '确认',
						callback: action => {
							
						}
					});
				  return false
		        }
				const imgtypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
				const vdotypes = ["video/mp4"];
				const isImg = imgtypes.includes(file.type)
				const isVdo = vdotypes.includes(file.type)
				if(isImg){
					this.houzhui='.jpg'
					this.acceptmedia='.jpeg, .png, .jpg, .gif'
					this.maxcount=9
				}
				if(this.acceptmedia=='.jpeg, .png, .jpg, .gif'){
					if(isVdo){
						this.$alert("视频与图片只能传一种，已传图片不能传视频", '视频与图片只能传一种', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
						return false
					}
				}
				if(isVdo){
					this.houzhui='.mp4'
					this.acceptmedia='.mp4'
					this.maxcount=1
				}
				if(this.acceptmedia=='.mp4'){
					if(isImg){
						this.$alert("视频与图片只能传一种，已传视频不能传图片", '视频与图片只能传一种', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
						return false
					}
				}
		    //     if (!isLt2M) {
		    //       this.$message.error("上传头像图片大小不能超过 2MB!");
				  // return
		    //     }
		        
		      },
		      // 
		      upload(params) {
		        console.log(params);
		        // 上传到腾讯云服务器 SDK(语法)
				var fileList=this.fileList;
				  let timeStart = Date.now();
				  var imagename=this.uuid+this.userdata.unionId+'yanxuequan'+timeStart;
				  var cos = new COS({
				      getAuthorization: function (options, callback) {
				          // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
				          // 异步获取临时密钥
						  var data=options.Scope
						  console.log(options.Scope)
				          getTempKeys(data).then(res=>{
							  var data = res.data.data;
								console.log('data',data);
								var credentials = data && data.credentials;
								console.log('credentials',credentials);
							  if (!data || !credentials) return console.error('credentials invalid');
							  callback({
							      TmpSecretId: credentials.tmpSecretId,        // 临时密钥的 tmpSecretId
							      TmpSecretKey: credentials.tmpSecretKey,      // 临时密钥的 tmpSecretKey
							      SecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
							      // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
							      StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
							      ExpiredTime: data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
									ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
							  });
						  })
				      }
				  });

		        // const cos = new COS({
		        //   SecretId: "AKIDB0ZtxlnfjXdU4N88dqmX3HCm56sEYAiz",
		        //   SecretKey: "EXZJmyuEG3g8Yh02qyGKDqDSSTFxWvFJ",
		        // });
		        cos.putObject(
		          {
		            Bucket: this.userdata.bucket /* 填入您自己的存储桶，必须字段 */,
		            Region: this.userdata.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
		            Key: '/handsign/group/'+imagename+this.houzhui /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
		            Body: params.file /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */,
		            onProgress: function (progressData) {
		              console.log(JSON.stringify(progressData));
		            },
		          },
		          (err, data) => {
		            console.log(err || data);
		            if (data) {
		              // 通知父亲
					  console.log('data',data)
					    fileList.push({ ...params.file, url:'http://'+data.Location,name:imagename+this.houzhui, });
						this.fileList=fileList
					    console.log(this.fileList)
						data={
						  title:'/handsign/group/' +imagename+this.houzhui,
						}
						checkUpload(data).then(res=>{
							if(res.data.code==200){
								this.$message({
									message: '上传成功',
									type: 'success'
								});
							}else{
								this.$message({
									message: res.data.msg,
									type: 'warning'
								});
							}
						})
					  
		            }
		          }
		        );
		      },
		        handleExceed(files, fileList) {
		          this.$message.warning(`上传数量超出`);
		        },
		        beforeRemove(file, fileList) {
					console.log('shanchu',file, this.fileList,fileList)
					// return
					var that=this
					var cos = new COS({
					    getAuthorization: function (options, callback) {
					        // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
					        // 异步获取临时密钥
							  var data=options.Scope
							  console.log(options.Scope)
					        getTempKeys(data).then(res=>{
								  var data = res.data.data;
									console.log('data',data);
									var credentials = data && data.credentials;
									console.log('credentials',credentials);
								  if (!data || !credentials) return console.error('credentials invalid');
								  callback({
									  TmpSecretId: credentials.tmpSecretId,        // 临时密钥的 tmpSecretId
									  TmpSecretKey: credentials.tmpSecretKey,      // 临时密钥的 tmpSecretKey
									  SecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
									  // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
									  StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
									  ExpiredTime: data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
										ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
								  });
							  })
					    }
					});
					cos.deleteObject({
						Bucket: this.userdata.bucket /* 填入您自己的存储桶，必须字段 */,
						Region: this.userdata.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
						Key: '/handsign/group/' +file.name, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
					}, function(err, data) {
						console.log(err || data);
						if(fileList.length==0){
							that.maxcount=9
							that.acceptmedia='.jpeg, .png, .jpg, .gif, .mp4'
						}
						that.fileList=fileList
						console.log('删除成功')
					});
					
				
				  
		        },
		  
		  commentpagechange(val){
			this.comment_pageindex=val
			this.getactcomment()
		  },
		  reply(){
			var token = localStorage.getItem('token')||''
			if(!token){
			  this.gologin()
			  return
			}
			var data={
			  
			}
			checktoken(data).then(res=>{
			  if(res.data.code==201){
				  console.log(res)
				  regettoken(data).then(res=>{
					  localStorage.setItem('token', res.data.data.token)
					  localStorage.setItem('refreshToken', res.data.data.refreshToken)
				  })
			  }
			  // if(res)
			})
			var imgs=[]
			var videos=''
			var list=this.fileList
			if(this.acceptmedia=='.jpeg, .png, .jpg, .gif'){
				for(var x=0;x<list.length;x++){
					imgs.push(list[x].url)
				}
			}else if(this.acceptmedia=='.mp4') {
				videos=list[0].url
			}
			data={
				type_id:this.uuid,
				type:3,
				content:this.replytext,
				imgs:imgs,
				videos:videos,
				star:this.replyrate,
			}
			if(!this.replytext){
			  this.$alert('请填写评论内容', '评论内容未填写', {
				confirmButtonText: '确认',
				callback: action => {
					
				}
			  });
			  return
			}
			ratecomment(data).then(res=>{
				if(res.data.code==200){
					this.$alert(res.data.data, '评论成功', {
						confirmButtonText: '确认',
						callback: action => {
							this.replytext=''
							this.replyrate=5
							this.fileList=[]
							this.maxcount=9
							this.acceptmedia='.jpeg, .png, .jpg, .gif, .mp4'
							this.getactcomment()
						}
					});
									 
				}
			})
					  
		  },
		  logout(){
			  var that=this
			  this.$confirm('是否确认退出登录?', '提示', {
			  					confirmButtonText: '确定',
			  					cancelButtonText: '取消',
			  					type: 'warning'
			  }).then(() => {
						this.$alert("已退出登录", '', {
							confirmButtonText: '确认',
							callback: action => {
								localStorage.setItem('token', '')
								localStorage.setItem('refreshToken', '')
								 that.$router.go(0)
							}
						  });
			  }).catch(() => {
			  		 
			  });
		  },
		  phonelogin(){
			  var data=this.form
			  var that=this
			  if(this.form.mobile==''){
						this.$alert('请输入登录手机号', '请输入登录手机号', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
				return;
			  }
			  if(this.form.mobile.length!=11){
						this.$alert('手机号长度位数错误', '手机号长度错误', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
				return;
			  }
			  if( this.form.password==''){
						this.$alert('请填写密码', '存在未填项', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
				return;
			  }
			  phonelogin(data).then(res=>{
				  if(res.data.data.flag==0){
				  					  this.$alert(res.data.data.msg, '账号不存在', {
				  					  	confirmButtonText: '确认',
				  					  	callback: action => {
				  					  		that.goregister()
				  					  	}
				  					  });
				  					  return
				  }
				  if(res.data.data.flag==2){
				  						  this.$alert(res.data.data.msg, '没有设置密码', {
				  							confirmButtonText: '确认',
				  							callback: action => {
				  								that.goreset()
				  							}
				  						  });
				  						  return
				  }
				  localStorage.setItem('token', res.data.data.token)
				  localStorage.setItem('refreshToken', res.data.data.refreshToken)
				  this.$router.go(0)
				  // this.$localStorage.set('token',res.data.data.token)
				  // this.$localStorage.set('refreshToken',res.data.data.refreshToken)
			  })
		  },
		  getactcomment(){
			var data={
			  type:3,
			  type_id:this.uuid,
			  page_index:this.comment_pageindex,
			  page_size:15,
			}  
			getactcomment(data).then(res=>{
				this.commentlist=res.data.data.list
				this.commenttotal=res.data.data.total
			})
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
			  this.$router.push({
			    path: "/register",
			    name: "/register",
			  		  query: {
			  		  }
			  });
		  },
		  goreset(e){
		  			  this.$router.push({
		  			    path: "/reset",
		  			    name: "/reset",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
		  getpcset(){
			var data={
				flag:99
			}
		  		getPc(data).then(res=>{
		  			this.pcsetdata=res.data.data
		  		})  
		  },
		  camptypetab(val){
		  			  this.category_id=val
		  			  this.getlist()
		  },
		  pagechange(val){
			  this.page_index=val
			   this._getNewslist()
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getActypes(data).then(res=>{
					console.log(res.data)
					this.types=res.data.data
					// this.category_id=res.data.data[0].id
					// this._getNewslist()
				}).catch(error => {
				  console.error(error);
				});
		  },
		getQuicklist(){
			var data={
				  page_index:1,
				  page_size:5,
			  }
			getActivitylist(data).then(res=>{
			  			  console.log(res.data)
						  this.quicklist=res.data.data.list
			  }).catch(error => {
			  			  console.error(error);
			  			});
		},
		  getDetails(){
		  			var data={
		  				// type:this.camptype,
		  				uuid:this.uuid
		  			}  
		  			getActivitylist(data).then(res=>{
						
		  				console.log(res.data)
		  				this.actdata=res.data.data
						this.getactcomment()
						const loading = this.$loading({
						         lock: true,
						         text: 'Loading',
						         spinner: 'el-icon-loading',
						         background: 'rgba(0, 0, 0, 0.7)'
						       });
						loading.close();
		  				// this.total=res.data.data.total
		  				// this.quicklist=res.data.data.list
		  			}).catch(error => {
		  				console.error(error);
		  			});
		  },
		
		   handleSelect(key, keyPath) {
		          console.log(key, keyPath);
		        },
	  }
	};
</script>

<style scoped>
	.wxcode_img{
		padding: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.upload-demo{
		text-align: left !important;
		width: 250px;
	}
	.replybox{
		padding: 20px;
		    border-bottom: 1px solid #ececec;
	}
	.reply_buttonbox{
		margin-top: 15px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.commentitem{
		padding: 20px;
		width: calc(100% - 40px);
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.replysbox{
		padding: 10px;
		background: #EBEEF5;
		border-radius: 5px;
		
	}
	.comment_more{
		padding: 10px;
	}
	.replys_item{
		
	}
	.reply_rate{
		/* font-size: 32px; */
		display: flex;
		margin-bottom: 10px;
	}
	.replys_text{
		text-align: left;
		font-size: 15px;
		margin-bottom: 6px;
	}
	.replys_time{
		
	}
	.comment_icon{
		width: 40px;
		height: 40px;
		
	}
	.comment_icon img{
		width: 100%;
		height: 100%;
	}
	.commentmainbox{
		width: 280px;
		
	}
	.comment_rate{
		width: 130px;
		margin-bottom: 10px;
		
	}
	.commentmaintext{
		font-size: 16px;
		text-align: left;
		color:#303133;
		margin-bottom: 10px;
	}
	.comment_medium{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		margin-bottom: 10px;
	}
	.medium_imgs{
		width: 80px;
		height: 80px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	.medium_imgs img{
		width: 100%;
		height: 100%;
	}
	.medium_video{
		width: 100%;
		height: 160px;
	}
	.comment_msg{
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		margin-bottom: 10px;
		color:#909399 ;
	}
</style>
<style >
	.baoming_tips{
		padding: 10px;
		font-size: 18px;
		color: #FE7C2B;
	}
	.main_box{
		width: 1180px;
		min-height: 600px;
		margin: 0 auto;
	}
	.acttop_box{
		width: 100%;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		background: #fff;
		/* padding: ; */
	}
	.acttop_imgs{
		width: 375px;
		padding: 20px 40px;
	}
	.acttop_msg{
		width:665px ;
		padding: 20px 40px;
		padding-left: 0px;
	}
	.actmain_box{
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: flex-start;
		
	}
	.act_main{
		width: 770px;
		margin-top: 20px;
		background: #fff;
	}
	.actmain_item{
		padding: 20px;
	}
	.actmain_title{
		font-size:20px;
		padding-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.actblock{
		width: 10px;
		height: 40px;
		margin-right: 20px;
		display: block;
		background: #FE7C2B;
	}
	::v-deep img{
	     max-width:100%;
	 }
</style>